<template>
  <div class="wrapper">
    <el-row :gutter="20">
      <el-col :span="6" :xs="12">
        <div class="card" @click="skipDeviceListStatus('1')">
          <img class="img" src="~@/assets/微信图片_20200402154627.png" />
          <div class="card-content">
            <div>在线设备/设备总数(台)</div>
            <div>
              {{ stat.onLineNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" :xs="12">
        <div class="card" @click="skipDeviceListStatus('0')">
          <img class="img" src="~@/assets/微信图片_20200402154621.png" />
          <div class="card-content">
            <div>离线设备/设备总数(台)</div>
            <div>
              {{ stat.offLineNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="6" :xs="24">
        <div
          class="card"
          style="cursor: pointer"
          @click="$router.push({ name: '未绑定设备' })"
        >
          <img class="img" src="../../../assets/9.png" />
          <div class="card-content">
            <div>未绑定设备/设备总数(台)</div>
            <div>
              {{ stat.unBindNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col> -->
    </el-row>

    <el-row :gutter="5" class="m-mp-10">
      <el-form ref="params" :model="params">
        <el-col :span="4" :xs="12">
          <el-form-item prop="id">
            <el-input v-model="params.id" placeholder="小区ID" maxlength="11" />
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="groupName">
            <el-input
              v-model="params.groupName"
              placeholder="小区名称"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="mobile">
            <el-input v-model="params.mobile" placeholder="手机号码" />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>

    <el-row style="margin-bottom: 10px" class="xs-mp-10">
      <el-col :span="3" :xs="12">
        <el-button type="primary" @click="handleAddCellBtnClick"
          >新增小区</el-button
        ></el-col
      >
    </el-row>

    <el-row :gutter="10">
      <el-col :span="6" :xs="24" v-for="item in records" :key="item.id">
        <lp-list-item :item="item" :rows="dataRows">
          <template #onLineSlot="scope">
            <el-tag
              type="primary"
              size="small"
              @click="skipDeviceList(scope.row, '1')"
              >{{ scope.row.onLineSize || 0 }}</el-tag
            >
            <div style="margin: 0 4px">/</div>
            <el-tag
              type="danger"
              size="small"
              @click="skipDeviceList(scope.row, '0')"
              >{{ scope.row.offLineSize || 0 }}</el-tag
            >
          </template>

          <template #option="scope">
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button size="mini" @click="edit(scope.row)"
                >修改小区</el-button
              >
            </div>
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button size="mini" type="danger" @click="remove(scope)"
                >删除小区</el-button
              >
            </div>
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button
                type="primary"
                size="mini"
                @click="addDevice(scope.row)"
                >新增设备</el-button
              >
            </div>
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button
                type="warning"
                size="mini"
                @click="syncConfig(scope.row)"
                >同步配置</el-button
              >
            </div>
            <!-- <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button
                type="info"
                size="mini"
                @click="configChargeTime(scope.row)"
                >配置充电时间</el-button
              >
            </div> -->
          </template>
        </lp-list-item>
      </el-col>
    </el-row>

    <!-- <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
    >
      <el-table-column label="小区ID" prop="id" width="100">
        <template #default="scope">
          <span class="click" @click="skipDeviceList(scope.row)">
            {{ scope.row.id }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed label="小区名称" prop="groupName" width="150">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.groupName"
            placement="top-start"
          >
            <span
              class="click text_ellipsis_1"
              @click="skipDeviceList(scope.row)"
            >
              {{ scope.row.groupName }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="设备总数" prop="deviceSize" />
      <el-table-column label="端口总数" prop="portSize">
        <template #default="scope">
          {{ scope.row.portSize || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="在线设备" prop="onLineSize">
        <template #default="scope">
          <span class="click" @click="skipDeviceList(scope.row, '1')">
            {{ scope.row.onLineSize || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="离线设备" prop="offLineSize">
        <template #default="scope">
          <span class="click" @click="skipDeviceList(scope.row, '0')">
            {{ scope.row.offLineSize || 0 }}
          </span>
        </template>
      </el-table-column> 
      <el-table-column label="手机号" prop="mobile" />
      <el-table-column label="区域" prop="city" /> 
      <el-table-column label="创建时间" prop="creatTime" width="180">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column> 
      <el-table-column label="操作" align="center" width="500">
        <template #default="scope">
          <el-button v-if="scope.row" size="mini" @click="edit(scope.row)"
            >修改小区</el-button
          >
          <el-button
            v-if="scope.row"
            size="mini"
            type="danger"
            @click="remove(scope)"
            >删除小区</el-button
          >
          <el-button
            v-if="scope.row"
            type="primary"
            size="mini"
            @click="addDevice(scope.row)"
            >新增设备</el-button
          >
          <el-button
            v-if="scope.row"
            type="warning"
            size="mini"
            @click="syncConfig(scope.row)"
            >同步配置</el-button
          >
          <el-button
            v-if="scope.row"
            type="info"
            size="mini"
            @click="configChargeTime(scope.row)"
            >配置充电时间</el-button
          >
        </template>
      </el-table-column>
    </el-table> -->
    <page :current="current" :size="size" :total="total" />
    <!-- <edit-group-dialog :dialog="editGroupDialog" :group="group" /> -->
    <add-group-dialog
      v-if="addGroupDialog"
      :dialog.sync="addGroupDialog"
      :group="group"
      :title="title"
      @fetchGroup="fetchData"
    />
    <sync-config-dialog
      v-if="syncConfigDialog"
      :dialog.sync="syncConfigDialog"
      :syncConfigId="syncConfigId"
    />
    <config-charge-time-dialog
      v-if="configChargeTimeDialog"
      :dialog.sync="configChargeTimeDialog"
      :configChargeTimeId="configChargeTimeId"
    />
    <remove-group-dialog :dialog="removeGroupDialog" :remove-id="removeId" />
    <add-power-station-dialog
      :dialog="addPowerStationDialog"
      v-if="addPowerStationDialog"
      :defaultGroupId="AddGroupId"
    />
  </div>
</template>

<script>
import maintainGetDeviceNumDetail from "@/maintain/api/device/charging-pile-manage/maintainGetDeviceNumDetail";
import maintainGetGroupListByPage from "@/maintain/api/device/device-group-manage/maintainGetGroupListByPage";

import Page from "@/components/Page";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";

import ConfigChargeTimeDialog from "@/maintain/components/PowerStationDialog/ConfigChargeTimeDialog";
import SyncConfigDialog from "@/maintain/components/PowerStationDialog/SyncConfigDialog";
import AddGroupDialog from "@/maintain/components/PowerStationDialog/addGroupDialog";
import AddPowerStationDialog from "@/maintain/components/PowerStationDialog/addPowerStationDialog";
import removeGroupDialog from "@/maintain/components/PowerStationManage/MyPowerStation/MyPowerStationThree/removeGroupDialog";

import createdMixin from "@/mixin/createMixin";
import formatPhone from "@/mixin/formatPhoneMixin";
import resDispose from "@/mixin/resDisposeMixin";
import timeMixin from "@/mixin/timeMixin";
import { Message } from "element-ui";
import { mapGetters } from "vuex";

import LpListItem from "@/components/LpListItem.vue";

export default {
  name: "CellManagement",
  components: {
    removeGroupDialog,
    AddPowerStationDialog,
    SyncConfigDialog,
    ConfigChargeTimeDialog,
    // EditGroupDialog,
    Page,
    AddGroupDialog,
    LpListItem,
  },
  mixins: [
    pageMixin,
    dialogMixin,
    searchMixin,
    createdMixin,
    timeMixin,
    resDispose,
  ],
  computed: {
    ...mapGetters(["info"]),
  },
  data() {
    return {
      syncConfigDialog: false,
      syncConfigId: "",
      configChargeTimeDialog: false,
      configChargeTimeId: "",
      addPowerStationDialog: false,
      group: {},
      editGroupDialog: false,
      removeGroupDialog: false,
      addGroupDialog: false,
      params: {
        sortName: "id",
        sortType: "DESC",
        id: undefined,
        groupName: undefined,
        mobile: undefined,
      },
      records: [],
      AddGroupId: "",
      groupNumber: "",
      groupName: "",
      groupForm: {
        name: "",
      },
      removeId: undefined,
      title: "",
      stat: {
        total: 0,
        onLineNum: 0,
        offLineNum: 0,
        unBindNum: 0,
      },
      dataRows: [
        {
          label: "小区名称",
          prop: "groupName",
          click: (row) => {
            this.skipDeviceList(row);
          },
        },
        {
          label: "小区ID",
          prop: "id",
          click: (row) => {
            this.skipDeviceList(row);
          },
        },
        {
          label: "设备/端口总数",
          prop: "portSize",
          format: (_, item) =>
            `${item.deviceSize || 0} / ${item.portSize || 0}`,
        },
        {
          label: "在线/离线设备",
          prop: "onLineSize",
          slot: "onLineSlot",
        },
        { label: "手机号", prop: "mobile" },
        {
          label: "创建时间",
          prop: "creatTime",
          format: (v) => this.timeFormat(v),
        },
      ],
    };
  },
  created() {
    maintainGetDeviceNumDetail().then((res) => {
      this.stat = res.data;
    });
  },
  watch: {
    "params.mobile": {
      handler() {
        this.params.mobile = formatPhone(this.params.mobile);
      },
    },
    "params.groupName": {
      handler(newV) {
        if (!newV) return;
        this.params.groupName = newV.trim();
      },
    },
  },
  // mounted() {
  //   this.refresh.$on("fetchGroup", this.fetchData);
  // },
  // beforeDestroy() {
  //   this.refresh.$off("fetchGroup", this.fetchData);
  // },
  methods: {
    skipDeviceList(row, status) {
      const query = { groupId: row.id };
      if (status !== undefined) {
        query.status = status;
      }
      this.$router.push({ name: "设备管理", query });
    },
    skipDeviceListStatus(status) {
      const query = {};
      if (status !== undefined) {
        query.status = status;
      }
      this.$router.push({ name: "设备管理", query });
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    fetchData() {
      this.loadTable = true;
      maintainGetGroupListByPage(this.current, this.size, this.params)
        .then((res) => {
          this.total = res.data.total;
          this.records = res.data.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    edit(group) {
      this.group = {};
      this.title = "修改小区";
      this.addGroupDialog = true;

      this.$nextTick(() => {
        this.group = group;
      });
    },
    remove(scope) {
      if (scope.row.deviceSize > 0) {
        return Message.warning("请先解绑所有设备后，再删除~");
      }
      this.removeGroupDialog = true;
      this.removeId = scope.row.id;
    },
    addDevice(scope) {
      this.addPowerStationDialog = true;
      this.AddGroupId = scope.id;
    },
    syncConfig(scope) {
      this.syncConfigDialog = true;
      this.syncConfigId = scope.id;
    },
    // 配置充电时间
    configChargeTime(scope) {
      // 配置充电时间弹框
      this.configChargeTimeDialog = true;
      this.configChargeTimeId = scope.id;
    },
    handleAddCellBtnClick() {
      this.group = {};
      this.title = "新增小区";
      this.addGroupDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .wrapper {
    .card {
      height: 80px !important;
      padding-left: 10px !important;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>

<style lang="scss" scoped>
.wrapper {
  padding: 10px;
  background: #fff;
  .card {
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    height: 120px;
    padding-left: 30px;
    margin-bottom: 10px;
    cursor: pointer;

    .img {
      width: 58px;
      height: 58px;
      display: block;
    }

    .card-content {
      margin-left: 10px;

      div:last-child {
        margin-top: 5px;
      }
    }
  }
}
</style>
